export default __webpack_public_path__ + "src/assets/migrate.6e372d3dc2df9636e701105d3457d07c.svg";